export default __webpack_public_path__ + "static/media/ms_fleet_icon.7a6aa08d.svg";